<template>
  <div class="l-footer-panel">
    <div v-on:click="openModalBox()" class="button">
      <div class="button__inner">
        <img :src="`${staticPath}img/factory/btn_ranking.png`">
      </div>
    </div>
    <transition>
      <div v-if="isOpenBox" class="modal-box">
        <div class="modal-box__inner">
          <div class="modal-box__panel">
            <div class="panel">

              <template v-if="panelScence == 1">

                <div class="tabs">
                  <div class="tabs__header">
                    <div v-on:click="selectPerson()" v-bind:class="{selected:selectedPerson}" class="tab">
                      <p>Personal</p>
                    </div>
                    <div v-on:click="selectTeam()" v-bind:class="{selected:selectedTeam}" class="tab">
                      <p>Team</p>
                    </div>
                  </div>
                  <div class="tabs__body">
      
                    <div v-show="selectedPerson" class="tab">
                      <div class="tab__top3">
                        <img :src="`${staticPath}img/factory/ranking/pnl_body_1_person.png`">
                      </div>
                      <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings">
                        <div class="tab__other">
                          <img :src="`${staticPath}img/factory/ranking/scene_1/pnl_body_2_person.png`">
                        </div>
                      </VuePerfectScrollbar>
                    </div>

                    <div v-show="selectedTeam" class="tab">
                      <div class="tab__top3">
                        <img :src="`${staticPath}img/factory/ranking/pnl_body_1_team.png`">
                      </div>
                      <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings">
                        <div class="tab__other">
                          <img :src="`${staticPath}img/factory/ranking/scene_1/pnl_body_2_team.png`">
                        </div>
                      </VuePerfectScrollbar>
                    </div>
                    
                  </div>
                </div>
              </template>

              <template v-else-if="panelScence == 2">

                <div class="tabs">
                  <div class="tabs__header">
                    <div v-on:click="selectPerson()" v-bind:class="{selected:selectedPerson}" class="tab">
                      <p>Personal</p>
                    </div>
                    <div v-on:click="selectTeam()" v-bind:class="{selected:selectedTeam}" class="tab">
                      <p>Team</p>
                    </div>
                  </div>
                  <div class="tabs__body">
      
                    <div v-show="selectedPerson" class="tab">
                      <div class="tab__top3">
                        <img :src="`${staticPath}img/factory/ranking/pnl_body_1_person.png`">
                      </div>
                      <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings">
                        <div class="tab__other">
                          <img :src="`${staticPath}img/factory/ranking/scene_2/pnl_body_2_person.png`">
                        </div>
                      </VuePerfectScrollbar>
                    </div>

                    <div v-show="selectedTeam" class="tab">
                      <div class="tab__top3">
                        <img :src="`${staticPath}img/factory/ranking/pnl_body_1_team.png`">
                      </div>
                      <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings">
                        <div class="tab__other">
                          <img :src="`${staticPath}img/factory/ranking/scene_2/pnl_body_2_team.png`">
                        </div>
                      </VuePerfectScrollbar>
                    </div>
                    
                  </div>
                </div>
              </template>

            </div>
          </div>
          <div v-on:click="closeModalBox()" class="modal-box__return">
            <img :src="`${staticPath}img/factory/btn_return.png`">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modal_box.scss';

  .panel {
    height: 100%;
    border-radius: 25px;
    background-color: #fff;
    overflow: hidden;
  }

  .panel__inner {
    height: 100%;
  }

  .tabs {
    height: 100%;
  }

  .tabs__header {
    display: flex;
    height: 50px;
    color: #fff;
    background-image: url($static-path + 'img/factory/ranking/pnl_header_bg.png');
    border-radius: 25px 25px 0 0;
    text-shadow: rgba(0,0,0,0.6) -1px 1px 0, rgba(0,0,0,0.6) 0 2px 0;
    font-size: 1.25em;
    font-weight: 700;
    line-height: 1.6;
    text-align: center;

    .tab {
      width: 50%;
      padding: 10px 0;

      &.selected {
        border-radius: 25px 25px 0 0;
        background-color: rgba(0,0,0,0.3);
      }
    }
  }

  .tabs__body {
    height: calc(100% - 50px);
    padding: 10px;
    border-radius: 0 0 25px 25px;
  }

  .tab {
    height: 100%;
  }

  .scroll-area {
    height: 52%;
    padding-right: 12px;
  }
</style>

<script>
  import Constant from '@/constant';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: 'Ranking',
    props: ['passedTestState'],

    components: {
      VuePerfectScrollbar
    },

    data(){
      return {
        staticPath: Constant.STATICPATH,
        panelScence: 1,
        selectedPerson: false,
        selectedTeam: false,
        isOpenBox: false,

        settings: {
          maxScrollbarLength: 300
        },
      }
    },

    created(){

      this.selectPerson();
    },

    methods: {

      openModalBox() {
        this.isOpenBox = true;
      },

      closeModalBox() {
        this.isOpenBox = false;
      },

      selectPerson() {
        this.selectedPerson = true;
        this.selectedTeam = false;
      },

      selectTeam() {
        this.selectedPerson = false;
        this.selectedTeam = true;
      },
    },

    watch: {

      // 合格テストリストの値を反映
      passedTestState(val) {

        const passed_items = this.$store.getters['PassedTest/items'];
        const passed_num = passed_items.length;

        if (passed_num > 0) {
          // 一つでも合格してればシーン２に移動
          this.panelScence = 2;
        }
      }
    }
  
  }
</script>





// WEBPACK FOOTER //
// src/components/Factory/Ranking.vue